/**
 * マッチング詳細のフローティングCTA
 * CTAセクション（.ModuleMatching__cta）以降では表示しない
 */
export default function matchingFloatingCta() {
  const floating = document.querySelector('.js-matching-floating-cta');
  const ctaSection = document.querySelector('.ModuleMatching__cta');

  if (!floating || !ctaSection) return;

  const setHidden = (hidden) => {
    floating.classList.toggle('-is-hidden', hidden);
    floating.toggleAttribute('inert', hidden);
    floating.setAttribute('aria-hidden', String(hidden));
  };

  // CTAセクションをちょっと入ったぐらいで非表示にするためのオフセット
  const hideOffset = 100;

  const update = () => {
    const { top } = ctaSection.getBoundingClientRect();
    setHidden(top + hideOffset <= window.innerHeight);
  };

  let ticking = false;
  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  };

  update();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
}
